import { createRequestActions } from '../utils';
import * as substanceTRTypes from './substanceTRTypes';

export const saveSubstanceTRs = createRequestActions(substanceTRTypes.SAVE_SUBSTANCE_TRs);
export const listSubstanceTR = createRequestActions(substanceTRTypes.SUBSTANCE_TR_LIST);
